export default function () {
  const widgetName = 'cardWidgetStats';
  const widgetOpts = cardWidgetStatsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 6,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    maxItemsVisible: 6,
    showDescription: true,
    slideshow: false,
    textOverImage: true,

    cardWidgetLoaded: function (data) {
      let countTo;
      const itemsCount = data.items.length;

      // Function starting
      if (itemsCount == 0) {
        $('.tier-4-container').remove();
      } else {
        $('<div class="h-stats-section__content animated"></div>').prependTo('#cardWidgetStats');
        $('<div class="h-stats-section__stats"></div>').appendTo('.h-stats-section__content');

        const items = data.items;

        items.forEach(function (item) {
          const stat = `
          <div class="cw-stat">
              <div>${item.Title}</div>
              <p>${item.Description}</p>
          </div>`;
          $('.h-stats-section__stats').append(stat);
        });

        function formatNumber(num) {
          return num.toLocaleString();
        }

        function animateNumbers(el) {
          countTo = el.attr('data-countNum');
          $({ countNum: el.text() }).animate(
            {
              countNum: countTo,
            },
            {
              duration: 3000,
              easing: 'swing',
              step: function () {
                if (el.hasClass('decimal')) {
                  el.text(formatNumber(Math.floor(this.countNum)));
                } else {
                  el.text(Math.floor(this.countNum));
                }
              },
              complete: function () {
                if (el.hasClass('decimal')) {
                  el.text(formatNumber(this.countNum));
                } else {
                  el.text(this.countNum);
                }
              },
            },
          );
        }

        $('#cardWidgetStats .cw-stat').each(function () {
          let title = $(this).find('div');
          let titleNumber = title.find('span');
          let titleNumberNum = title.find('span').text();
          titleNumber.text('0');
          titleNumber.addClass('js-countNum');
          titleNumber.attr('data-countNum', titleNumberNum);
        });

        let cw3 = $('#cardWidgetStats .js-countNum');
        let cw3top = cw3.offset().top;
        let animated = false;
        let vpBtm = $(window).scrollTop() + $(window).height();

        function triggerAnimation(p) {
          if (cw3top < p && !animated) {
            cw3.each(function () {
              animateNumbers($(this));
            });
            animated = true;
          }
        }

        triggerAnimation(vpBtm);

        $(window).scroll(function () {
          let vpBtm = $(window).scrollTop() + $(window).height();
          triggerAnimation(vpBtm);
        });

        $(`#${widgetName} .card-widget-item`).remove();
        // Function finish
      }
    },
  });
}
